var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.103 7.7773L14.81 1.0793C14.8751 1.01385 14.9527 0.962126 15.0382 0.927202C15.1236 0.892278 15.2152 0.874859 15.3075 0.875978C15.3999 0.877097 15.491 0.896731 15.5756 0.933716C15.6602 0.970702 15.7365 1.02429 15.8 1.0913C15.9301 1.22836 16.0016 1.41076 15.9994 1.59973C15.9972 1.78871 15.9213 1.96936 15.788 2.1033L8.585 9.2963C8.52037 9.36137 8.44341 9.4129 8.35863 9.44789C8.27386 9.48287 8.18295 9.5006 8.09124 9.50004C7.99953 9.49948 7.90885 9.48064 7.8245 9.44463C7.74016 9.40862 7.66383 9.35615 7.6 9.2903L0.205 1.7193C0.0741232 1.58376 0.000976562 1.40271 0.000976562 1.2143C0.000976562 1.02589 0.0741232 0.844834 0.205 0.709298C0.269313 0.643073 0.34626 0.590426 0.431286 0.554475C0.516312 0.518524 0.607687 0.5 0.700001 0.5C0.792314 0.5 0.883689 0.518524 0.968715 0.554475C1.05374 0.590426 1.13069 0.643073 1.195 0.709298L8.103 7.7773Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownAccordion);
export default __webpack_public_path__ + "static/media/down-accordion.9dc867a26b1183a01845acee084413c7.svg";
export { ForwardRef as ReactComponent };